module.exports = __webpack_public_path__ + "static/media/34_tn.34a13386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/34_tn.jpg
// module id = 522
// module chunks = 0